import { materiales } from "./libraryConstants";
import ApiURLs from "config/ApiURLs";

export const colections = [
  /* {
    displayText: "Todo Cirma",
    value: " ",
    selected: false,
    disabled: false,
    searchfields: [],
  },
  {
    value: "CIRMA-AH",
    displayText: "Archivo Histórico",
    selected: false,
    sortby: [
      {
        displayText: "Colección",
        selected: false,
        value: "sortisadgid",
      },
      {
        displayText: "Título",
        selected: false,
        value: "sorttitle",
      },
      {
        displayText: "Autor",
        selected: false,
        value: "sortauthor",
      },
      {
        displayText: "Fecha",
        selected: false,
        value: "sortdate",
      },
    ],
    searchfields: [
      {
        displayText: "Título",
        value: "titulo",
        type: "text",
      },
      {
        displayText: "Autor",
        value: "autor",
        type: "text",
      },
      {
        displayText: "Productor",
        value: "producer",
        type: "text",
      },
      // {
      //   displayText: "Fecha Inicial",
      //   value: "from",
      //   type: "text",
      // },
      // {
      //   displayText: "Fecha Final",
      //   value: "to",
      //   type: "text",
      // },
      // {
      //   displayText: "Idioma",
      //   value: "idioma",
      //   placeholder: "Todos los Idiomas",
      //   type: "dropDown",
      //   urlToFetch: `${ApiURLs.libraryApiUrl}language`,
      //   values: [],
      // },
      {
        displayText: "Colecciones",
        value: "isadg",
        placeholder: "Todas las colecciones",
        type: "select",
        urlToFetch: `${ApiURLs.ApiUrl}collections?forfilter=names&repository=CIRMA-AH`,
        values: [],
      },
    ],
  },
  {
    value: "CIRMA-BIB",
    displayText: "Biblioteca de Ciencias Sociales",
    selected: false,
    searchfields: [
      {
        displayText: "Título",
        value: "titulo",
        type: "text",
      },
      {
        displayText: "Autor",
        value: "autor",
        type: "text",
      },
      // {
      //   displayText: "Idioma",
      //   value: "idioma",
      //   placeholder: "Todos los Idiomas",
      //   type: "dropDown",
      //   urlToFetch: `${ApiURLs.libraryApiUrl}language`,
      //   values: [],
      // },
      {
        displayText: "Material",
        value: "material",
        placeholder: "Todos los Materiales",
        type: "select",
        multivalue: true,
        // urlToFetch: `${ApiURLs.libraryApiUrl}material`,
        values: materiales,
      },
    ],
    sortby: [
      {
        displayText: "Título",
        selected: false,
        value: "sorttitle",
      },
      {
        displayText: "Autor",
        selected: false,
        value: "sortauthor",
      },
      {
        displayText: "Clasificación",
        selected: false,
        value: "sortclasification",
      },
    ],
  },
  {
    value: "CIRMA-FG",
    displayText: "Fototeca Guatemala",
    selected: false,
    sortby: [
      {
        displayText: "Colección",
        selected: false,
        value: "sortisadgid",
      },
      {
        displayText: "Título",
        selected: false,
        value: "sorttitle",
      },
      {
        displayText: "Autor",
        selected: false,
        value: "sortauthor",
      },
      {
        displayText: "Fecha",
        selected: false,
        value: "sortdate",
      },
    ],
    searchfields: [
      {
        displayText: "Título",
        value: "titulo",
        type: "text",
      },
      {
        displayText: "Autor",
        value: "autor",
        type: "text",
      },
      {
        displayText: "Productor",
        value: "producer",
        type: "text",
      },
      // {
      //   displayText: "Fecha Inicial",
      //   value: "from",
      //   type: "text",
      // },
      // {
      //   displayText: "Fecha Final",
      //   value: "to",
      //   type: "text",
      // },
      // {
      //   displayText: "Idioma",
      //   value: "idioma",
      //   placeholder: "Todos los Idiomas",
      //   type: "dropDown",
      //   urlToFetch: `${ApiURLs.libraryApiUrl}language`,
      //   values: [],
      // },
      {
        displayText: "Colecciones",
        value: "isadg",
        placeholder: "Todas las colecciones",
        type: "select",
        urlToFetch: `${ApiURLs.ApiUrl}collections?forfilter=names&repository=CIRMA-FG`,
        values: [],
      },
    ],
  }, */
  {
    value: "TAMI",
    displayText: "TAMI",
    selected: false,
    isDefault: true,
    sortby: [
      {
        displayText: "Date",
        selected: false,
        value: "isodate",
      },
      {
        displayText: "Title",
        selected: false,
        value: "sorttitle",
      }
    ],
    searchfields: [
      {
        displayText: "Filter by Content",
        value: "contenttype",
        type: "select",
        values: [
          { value: "rich_media_archive", label: "Videos" },
          { value: "web_exhibit", label: "Web Exhibits" },
          { value: "news", label: "News & Events" },
          { value: "content_lesson_plan", label: "Education" },
          { value: "category_video_tami", label: "Category" },
        ],
      },
      {
        displayText: "Filter by Topic",
        value: "category",
        type: "select",
        urlToFetch: `${ApiURLs.ApiUrl}/v1/website/video-categories`,
        values: [],
      },
      {
        displayText: "Filter by Decades",
        value: "decade",
        type: "select",
        urlToFetch: `${ApiURLs.ApiUrl}/glifos/api/video/decades`,
        values: [],
      },
      {
        displayText: "Filter by Location",
        value: "location",
        type: "select",
        urlToFetch: `${ApiURLs.ApiUrl}/glifos/api/video/location`,
        values: [],
      },
     /*  {
        displayText: "From",
        value: "datefrom",
        type: "date",
      },
      {
        displayText: "To",
        value: "dateto",
        type: "date",
      } */
      
    ],

    dateshandler: {
      startDate: {
        displayText: "From",
        
      },
      endDate: "dateto",
    },

  }
];
